import { type LoaderProps, default as Loader } from '@CS/components/Loader';

export const useLoader = (loading: boolean, props?: LoaderProps) =>
  loading ? <Loader {...props} /> : null;
